import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../../context/AuthContext";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      toast.success("Welcome back, Vee");
      navigate("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Login failed. Check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-obsidian flex items-center justify-center px-5">
      <div className="w-full max-w-md">
        <Link to="/" className="block text-center mb-10">
          <span className="font-heading text-3xl text-ink">Trendy threads by Vee</span>
          <span className="block font-accent text-[10px] tracking-[0.35em] uppercase text-champagne mt-1">
            Admin Studio
          </span>
        </Link>

        <form
          onSubmit={submit}
          data-testid="admin-login-form"
          className="bg-obsidian-2 border border-white/10 p-8 sm:p-10"
        >
          <h1 className="font-heading text-3xl text-ink mb-1">Sign in</h1>
          <p className="text-ash text-sm mb-8">Manage your collection &amp; brand details.</p>

          <label className="block font-accent text-[10px] tracking-[0.25em] uppercase text-ash mb-2">Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="login-email"
            required
            className="w-full bg-obsidian-3 border border-white/10 text-ink px-4 py-3 mb-5 focus:outline-none focus:border-champagne/60 transition-colors"
          />

          <label className="block font-accent text-[10px] tracking-[0.25em] uppercase text-ash mb-2">Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="login-password"
            required
            className="w-full bg-obsidian-3 border border-white/10 text-ink px-4 py-3 mb-6 focus:outline-none focus:border-champagne/60 transition-colors"
          />

          {error && <p data-testid="login-error" className="text-red-400 text-sm mb-4">{error}</p>}

          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="w-full bg-champagne text-obsidian font-accent text-xs tracking-[0.2em] uppercase py-4 hover:bg-champagne-hover transition-colors disabled:opacity-50"
          >
            {loading ? "Signing in…" : "Enter Studio"}
          </button>
        </form>
        <Link to="/" className="block text-center text-ash/50 text-xs tracking-wider mt-6 hover:text-champagne transition-colors">
          ← Back to site
        </Link>
      </div>
    </div>
  );
}
